import BestPriceIconEs from './best-price-icon-es';
import BestPriceIconPt from './best-price-icon-pt';
import PropTypes from 'prop-types';
import { useCulture } from 'context/CultureContext';

const BestPriceGuaranteedIcon = ({ size = 200 }) => {
    const { culture } = useCulture();

    return (
        <>
            {culture === 'pt-br' ?
                <BestPriceIconPt height={size * 1.4} width={size * 1.4} /> :
                <BestPriceIconEs height={size} width={size} />
            }
        </>
    );
};

BestPriceGuaranteedIcon.propTypes = {
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    whiteBackground: PropTypes.bool
};

export default BestPriceGuaranteedIcon;
